<template>
	<div class="wrap">
		<el-row class="tag color-orange" v-if="!showAll">
					<el-col :span="18" class="tag_text">
						<i class="el-icon-circle-close"></i>
						未完成此患者的心理评估，无法自动生成心理处方，请前去完成评估
					</el-col>
					<el-col :span="6" class="tag_text tag_text_right">
						<!-- <a @click="onEvalShow(sideEvalList)" class="goto">去评估</a> -->
					</el-col>
				</el-row>
		<template v-if="showAll">
		<div v-if="isShow">
			<el-row class="tag color-grey" v-if="tag && !hidden && !isSave">
				<el-col :span="18" class="tag_text">
					<i class="el-icon-info"></i>
					已完成对患者的心理评估，自动生成心理处方，请医生确认后发布
				</el-col>
				<el-col :span="6" class="tag_text tag_text_right">
					<a @click="isHidden" class="know">我知道了</a>
				</el-col>
			</el-row>
		</div>
		<el-form ref="form" :model="form" :rules="rules" label-width="80px">
			<div class="body" id="psychology">
				<div class="item">
					<h2 class="cf">心理处方</h2>
				</div>
				<div v-show="tag" class="item">
					<div class="title">
						诊断结果
					<el-button class="exportPdf" v-if="!showSaveBtn" :loading="isLoading" @click="exportPdf">导出处方</el-button>

					</div>
					<div class="text">
						{{form.result}}
					</div>
				</div>
				<div class="mTop10">
					<div class="title item">
						处方内容
					</div>
					<div>
						<div v-show="!isSave">
							<div class="m20">
								<el-checkbox v-model="form.content.somatizationCheck" @change="changeVal">躯体化</el-checkbox>
							</div>
							<div class="tips" v-show="form.content.somatizationCheck">
								躯体化是指人们在发生心理不适或内在的压力长期得不到适当的释放时，不是或较少以焦虑、恐惧及情绪变化等心理化的方式呈现，而可能是以头痛、腰痛和胸痛等躯体症状的方式呈现。最常见的躯体化症状为头昏、头痛、耳鸣、乏力、睡眠障碍、胸闷、心慌、慢性疼痛、咽喉梗阻、厌食、腹胀、尿频等，但其躯体症状与相应的医学检查不符，对症治疗效果往往不佳，采用心理调适的方法可能效果更好。
							</div>
							<el-form-item label="" prop="content.somatization" label-width="0"
								v-show="form.content.somatizationCheck">
								<el-input type="textarea" placeholder="请输入处方内容" v-model="form.content.somatization"
									:rows="3"></el-input>
							</el-form-item>
							<div class="m20">
								<el-checkbox v-model="form.content.forcedCheck" @change="changeVal">强迫症状</el-checkbox>
							</div>
							<div class="tips" v-show="form.content.forcedCheck">
								强迫症状是强迫思维或强迫行为或两者表现同时存在的一种精神心理表现。一般表现为头脑里反复出现某一观念、意向或情绪，或对明知已做好的事情不放心，反复检查，反复核对，或在日常活动中一定要做某些程序的动作，否则会感到不安等。
							</div>
							<el-form-item label="" prop="content.forced" label-width="0"
								v-show="form.content.forcedCheck">
								<el-input type="textarea" placeholder="请输入处方内容" v-model="form.content.forced" :rows="3">
								</el-input>
							</el-form-item>
							<div class="m20">
								<el-checkbox v-model="form.content.relationshipCheck" @change="changeVal">人际关系敏感</el-checkbox>
							</div>
							<div class="tips" v-show="form.content.relationshipCheck">
								人际关系敏感是指与人相处时比较在意别人的反应或有一定的戒备心理，比如对别人的拒绝、冷淡、关注不够或过分关注过分在意或有较明显的心理感受，容易给自己造成一定的心理负担，影响人际关系的融洽。
							</div>
							<el-form-item label="" prop="content.relationship" label-width="0"
								v-show="form.content.relationshipCheck">
								<el-input type="textarea" placeholder="请输入处方内容" v-model="form.content.relationship"
									:rows="3"></el-input>
							</el-form-item>
							<div class="m20">
								<el-checkbox v-model="form.content.depressionCheck" @change="changeVal">抑郁</el-checkbox>
							</div>
							<div class="tips" v-show="form.content.depressionCheck">
								抑郁是一种负面情绪表现，是现代人心理障碍最重要的表现类型，有抑郁倾向的人容易悲观的失落，做事主观能动性低，担心自己不如别人，高兴不起来，容易有孤独的感觉。
							</div>
							<el-form-item label="" prop="content.depression" label-width="0"
								v-show="form.content.depressionCheck">
								<el-input type="textarea" placeholder="请输入处方内容" v-model="form.content.depression"
									:rows="3"></el-input>
							</el-form-item>
							<div class="m20">
								<el-checkbox v-model="form.content.anxietyCheck" @change="changeVal">焦虑</el-checkbox>
							</div>
							<div class="tips" v-show="form.content.anxietyCheck">
								焦虑有心理焦虑和身体焦虑表现，心理的焦虑是容易过度紧张、担忧、恐惧,躯体的焦虑往往就是指身体上表露出来的不适感，如胸闷、心慌、出汗、手抖、脸红、失眠等，而且随着心理焦虑的加重躯体的症状会更加明显。
							</div>
							<el-form-item label="" prop="content.anxiety" label-width="0"
								v-show="form.content.anxietyCheck">
								<el-input type="textarea" placeholder="请输入处方内容" v-model="form.content.anxiety"
									:rows="3"></el-input>
							</el-form-item>
							<div class="m20">
								<el-checkbox v-model="form.content.hostileCheck" @change="changeVal">敌对</el-checkbox>
							</div>
							<div class="tips" v-show="form.content.hostileCheck">
								有敌对心理倾向的人容易敏感、多疑，容易感觉自己受到他人的轻视、指责或伤害,因而对看不顺眼、不满或厌恶的人容易表现出较真儿、冷眼相对、动则非难等不良情绪。
							</div>
							<el-form-item label="" prop="content.hostile" label-width="0"
								v-show="form.content.hostileCheck">
								<el-input type="textarea" placeholder="请输入处方内容" v-model="form.content.hostile"
									:rows="3"></el-input>
							</el-form-item>
							<div class="m20">
								<el-checkbox v-model="form.content.terroristCheck" @change="changeVal">恐怖</el-checkbox>
							</div>
							<div class="tips" v-show="form.content.terroristCheck">
								恐怖是一种害怕不安的心理倾向，一般表现为过度的担心和害怕，因而容易有意回避一些特定环境、人物、事件或不敢做一些事情。
							</div>
							<el-form-item label="" prop="content.terrorist" label-width="0"
								v-show="form.content.terroristCheck">
								<el-input type="textarea" placeholder="请输入处方内容" v-model="form.content.terrorist"
									:rows="3"></el-input>
							</el-form-item>
							<div class="m20">
								<el-checkbox v-model="form.content.paranoidCheck" @change="changeVal">偏执</el-checkbox>
							</div>
							<div class="tips" v-show="form.content.paranoidCheck">
								有偏执倾向者性格比较固执，容易过分相信自己的判断并与他人发生争辩和对抗，对别人的错包容度小，容易造成人际关系紧张和不融洽。
							</div>
							<el-form-item label="" prop="content.paranoid" label-width="0"
								v-show="form.content.paranoidCheck">
								<el-input type="textarea" placeholder="请输入处方内容" v-model="form.content.paranoid"
									:rows="3"></el-input>
							</el-form-item>
							<div class="m20">
								<el-checkbox v-model="form.content.illnessCheck" @change="changeVal">精神病性</el-checkbox>
							</div>
							<div class="tips" v-show="form.content.illnessCheck">
								精神病性倾向者提示情绪控制力和逻辑思维能力偏弱，易出现凭空想象和敏感多疑的表现，对人际交往会造成一定影响。
							</div>
							<el-form-item label="" prop="content.illness" label-width="0"
								v-show="form.content.illnessCheck">
								<el-input type="textarea" placeholder="请输入处方内容" v-model="form.content.illness"
									:rows="3"></el-input>
							</el-form-item>
						</div>
						<div v-show="isSave">
							<div class="item" v-show="form.content.somatizationCheck">
								<div class="m20">
									<div class="sx"></div>躯体化
								</div>
								<div class="tips">
									躯体化是指人们在发生心理不适或内在的压力长期得不到适当的释放时，不是或较少以焦虑、恐惧及情绪变化等心理化的方式呈现，而可能是以头痛、腰痛和胸痛等躯体症状的方式呈现。最常见的躯体化症状为头昏、头痛、耳鸣、乏力、睡眠障碍、胸闷、心慌、慢性疼痛、咽喉梗阻、厌食、腹胀、尿频等，但其躯体症状与相应的医学检查不符，对症治疗效果往往不佳，采用心理调适的方法可能效果更好。
								</div>
								<div class="desc">
									{{form.content.somatization}}
								</div>
							</div>
							<div class="item" v-show="form.content.forcedCheck">
								<div class="m20">
									<div class="sx"></div>强迫症状
								</div>
								<div class="tips">
									强迫症状是强迫思维或强迫行为或两者表现同时存在的一种精神心理表现。一般表现为头脑里反复出现某一观念、意向或情绪，或对明知已做好的事情不放心，反复检查，反复核对，或在日常活动中一定要做某些程序的动作，否则会感到不安等。
								</div>
								<div class="desc">
									{{form.content.forced}}
								</div>
							</div>
							<div class="item" v-show="form.content.relationshipCheck">
								<div class="m20">
									<div class="sx"></div>人际关系敏感
								</div>
								<div class="tips">
									人际关系敏感是指与人相处时比较在意别人的反应或有一定的戒备心理，比如对别人的拒绝、冷淡、关注不够或过分关注过分在意或有较明显的心理感受，容易给自己造成一定的心理负担，影响人际关系的融洽。
								</div>
								<div class="desc">
									{{form.content.relationship}}
								</div>
							</div>
							<div class="item" v-show="form.content.depressionCheck">
								<div class="m20">
									<div class="sx"></div>抑郁
								</div>
								<div class="tips">
									抑郁是一种负面情绪表现，是现代人心理障碍最重要的表现类型，有抑郁倾向的人容易悲观的失落，做事主观能动性低，担心自己不如别人，高兴不起来，容易有孤独的感觉。
								</div>
								<div class="desc">
									{{form.content.depression}}
								</div>
							</div>
							<div class="item" v-show="form.content.anxietyCheck">
								<div class="m20">
									<div class="sx"></div>焦虑
								</div>
								<div class="tips">
									焦虑有心理焦虑和身体焦虑表现，心理的焦虑是容易过度紧张、担忧、恐
									惧,躯体的焦虑往往就是指身体上表露出来的不适感，如胸闷、心慌、出汗、手抖、脸红、失眠等，而且随着心理焦虑的加重躯体的症状会更加明显。
								</div>
								<div class="desc">
									{{form.content.anxiety}}
								</div>
							</div>
							<div class="item" v-show="form.content.hostileCheck">
								<div class="m20">
									<div class="sx"></div>敌对
								</div>
								<div class="tips">
									有敌对心理倾向的人容易敏感、多疑，容易感觉自己受到他人的轻视、指责或伤害,因而对看不顺眼、不满或厌恶的人容易表现出较真儿、冷眼相对、动则非难等不良情绪。
								</div>
								<div class="desc">
									{{form.content.hostile}}
								</div>
							</div>
							<div class="item" v-show="form.content.terroristCheck">
								<div class="m20">
									<div class="sx"></div>恐怖
								</div>
								<div class="tips">
									恐怖是一种害怕不安的心理倾向，一般表现为过度的担心和害怕，因而容易有意回避一些特定环境、人物、事件或不敢做一些事情。
								</div>
								<div class="desc">
									{{form.content.terrorist}}
								</div>
							</div>
							<div class="item" v-show="form.content.paranoidCheck">
								<div class="m20">
									<div class="sx"></div>偏执
								</div>
								<div class="tips">
									有偏执倾向者性格比较固执，容易过分相信自己的判断并与他人发生争辩和对抗，对别人的错包容度小，容易造成人际关系紧张和不融洽。
								</div>
								<div class="desc">
									{{form.content.paranoid}}
								</div>
							</div>
							<div class="item" v-show="form.content.illnessCheck">
								<div class="m20">
									<div class="sx"></div>精神病性
								</div>
								<div class="tips">
									精神病性倾向者提示情绪控制力和逻辑思维能力偏弱，易出现凭空想象和敏感多疑的表现，对人际交往会造成一定影响。
								</div>
								<div class="desc">
									{{form.content.illness}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<el-row class="dealwith">
					<el-col :span="12"  v-if="!showSaveBtn">
						责任医师：{{form.name}}<br/>
						发布时间：{{form.time}}
					</el-col>
					<el-col :span="12" class="tag_text_right" v-if="prescriptionItem &&prescriptionItem.hospitalPsychologicalVO?.pushTime">
						推送时间：{{prescriptionItem.hospitalPsychologicalVO.pushTime}}
					</el-col>
				</el-row>
			</div>
			
			<div class="body hide" id="psychology_print">
				<div class="item">
					<h2 class="cf">心理处方</h2>
				</div>
				<div style="color: #333;font-weight: normal;margin:16px 0;text-align: center;">姓名：{{ medicalRecordDetail.patientName}}&nbsp;&nbsp;&nbsp;&nbsp;科室：{{ medicalRecordDetail.department}}&nbsp;&nbsp;&nbsp;&nbsp;床号：{{medicalRecordDetail.inpatientArea}}-{{ medicalRecordDetail.hospitalBed}}床</div>
				<div v-show="tag" class="item">
					<div class="title">
						诊断结果
					</div>
					<div class="text">
						{{form.result}}
					</div>
				</div>
				<div class="mTop10">
					<div class="title item">
						处方内容
					</div>
					<div>
						<div v-show="isSave">
							<div class="item" v-show="form.content.somatizationCheck">
								<div class="m20">
									<div class="sx"></div>躯体化
								</div>
								<div class="tips">
									躯体化是指人们在发生心理不适或内在的压力长期得不到适当的释放时，不是或较少以焦虑、恐惧及情绪变化等心理化的方式呈现，而可能是以头痛、腰痛和胸痛等躯体症状的方式呈现。最常见的躯体化症状为头昏、头痛、耳鸣、乏力、睡眠障碍、胸闷、心慌、慢性疼痛、咽喉梗阻、厌食、腹胀、尿频等，但其躯体症状与相应的医学检查不符，对症治疗效果往往不佳，采用心理调适的方法可能效果更好。
								</div>
								<div class="desc">
									{{form.content.somatization}}
								</div>
							</div>
							<div class="item" v-show="form.content.forcedCheck">
								<div class="m20">
									<div class="sx"></div>强迫症状
								</div>
								<div class="tips">
									强迫症状是强迫思维或强迫行为或两者表现同时存在的一种精神心理表现。一般表现为头脑里反复出现某一观念、意向或情绪，或对明知已做好的事情不放心，反复检查，反复核对，或在日常活动中一定要做某些程序的动作，否则会感到不安等。
								</div>
								<div class="desc">
									{{form.content.forced}}
								</div>
							</div>
							<div class="item" v-show="form.content.relationshipCheck">
								<div class="m20">
									<div class="sx"></div>人际关系敏感
								</div>
								<div class="tips">
									人际关系敏感是指与人相处时比较在意别人的反应或有一定的戒备心理，比如对别人的拒绝、冷淡、关注不够或过分关注过分在意或有较明显的心理感受，容易给自己造成一定的心理负担，影响人际关系的融洽。
								</div>
								<div class="desc">
									{{form.content.relationship}}
								</div>
							</div>
							<div class="item" v-show="form.content.depressionCheck">
								<div class="m20">
									<div class="sx"></div>抑郁
								</div>
								<div class="tips">
									抑郁是一种负面情绪表现，是现代人心理障碍最重要的表现类型，有抑郁倾向的人容易悲观的失落，做事主观能动性低，担心自己不如别人，高兴不起来，容易有孤独的感觉。
								</div>
								<div class="desc">
									{{form.content.depression}}
								</div>
							</div>
							<div class="item" v-show="form.content.anxietyCheck">
								<div class="m20">
									<div class="sx"></div>焦虑
								</div>
								<div class="tips">
									焦虑有心理焦虑和身体焦虑表现，心理的焦虑是容易过度紧张、担忧、恐
									惧,躯体的焦虑往往就是指身体上表露出来的不适感，如胸闷、心慌、出汗、手抖、脸红、失眠等，而且随着心理焦虑的加重躯体的症状会更加明显。
								</div>
								<div class="desc">
									{{form.content.anxiety}}
								</div>
							</div>
							<div class="item" v-show="form.content.hostileCheck">
								<div class="m20">
									<div class="sx"></div>敌对
								</div>
								<div class="tips">
									有敌对心理倾向的人容易敏感、多疑，容易感觉自己受到他人的轻视、指责或伤害,因而对看不顺眼、不满或厌恶的人容易表现出较真儿、冷眼相对、动则非难等不良情绪。
								</div>
								<div class="desc">
									{{form.content.hostile}}
								</div>
							</div>
							<div class="item" v-show="form.content.terroristCheck">
								<div class="m20">
									<div class="sx"></div>恐怖
								</div>
								<div class="tips">
									恐怖是一种害怕不安的心理倾向，一般表现为过度的担心和害怕，因而容易有意回避一些特定环境、人物、事件或不敢做一些事情。
								</div>
								<div class="desc">
									{{form.content.terrorist}}
								</div>
							</div>
							<div class="item" v-show="form.content.paranoidCheck">
								<div class="m20">
									<div class="sx"></div>偏执
								</div>
								<div class="tips">
									有偏执倾向者性格比较固执，容易过分相信自己的判断并与他人发生争辩和对抗，对别人的错包容度小，容易造成人际关系紧张和不融洽。
								</div>
								<div class="desc">
									{{form.content.paranoid}}
								</div>
							</div>
							<div class="item" v-show="form.content.illnessCheck">
								<div class="m20">
									<div class="sx"></div>精神病性
								</div>
								<div class="tips">
									精神病性倾向者提示情绪控制力和逻辑思维能力偏弱，易出现凭空想象和敏感多疑的表现，对人际交往会造成一定影响。
								</div>
								<div class="desc">
									{{form.content.illness}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<el-row v-if="!showSaveBtn" class="dealwith">
					<el-col :span="12">
						责任医师：{{form.name}}
					</el-col>
					<el-col :span="12" class="tag_text_right">
						发布时间：{{form.time}}
					</el-col>
				</el-row>
			</div>
			
			<div v-show="isShow">
				<div class="save" v-if="showSaveBtn">
					<el-button type="primary" :loading="isLoading" @click="save('form')">发 布</el-button>
				</div>
				<div class="save" v-if="!showSaveBtn">
					<el-popconfirm confirmButtonText='删除' title="确定删除处方吗？" @confirm="delPrescription">
						<el-button slot="reference" style="float: left;" type="danger" :loading="isLoading" >删除处方</el-button>
					</el-popconfirm>

					<el-button type="primary" :loading="isLoading" @click="update">修改处方</el-button>
					<el-button :loading="isLoading" @click="dialogVisible=true" v-if="patientInfo.wxBindingState == 1">推送处方</el-button>
					<span style="opacity: 0;">{{ this.prescriptionItem.hospitalPsychologicalVO.id}}</span>

				</div>
			</div>
		</el-form>
	</template>

		<SendDialog v-if="dialogVisible" :dialogVisible.sync="dialogVisible" type="4" :prescriptionId="prescriptionItem?.hospitalPsychologicalVO.id" />

	</div>
</template>

<script>
	import api from '@/service/api.js';
	import htmlToPdf from '@/service/htmlToPdf'
	import SendDialog from './sendDialog.vue';

	export default {
		components: {
			SendDialog
		},
		props: {
			patientInfo:{
				required: true
			},
			recordId: {
				required: true
			},
			patientId: {
				required: true
			},
			datasources: {
				// required: true
				default: null

			},
			onEvalShow: {
				type: Function,
				default: null
			},
			isShow: {
				type: Boolean,
				default: true
			},
			sideEvalList:{
				// required: true
				default: null

			},
			medicalRecordDetail:{
				// required:true
				default: null

			}
		},
		data() {
			return {
				tag: true,
				hidden: false,
				form: {
					result: "",
					content: {
						somatization: "",
						forced: "",
						relationship: "",
						depression: "",
						anxiety: "",
						hostile: "",
						terrorist: "",
						paranoid: "",
						illness: "",
						somatizationCheck: true,
						forcedCheck: true,
						relationshipCheck: true,
						depressionCheck: true,
						anxietyCheck: true,
						hostileCheck: true,
						terroristCheck: true,
						paranoidCheck: true,
						illnessCheck: true
					},
					name: "",
					time: "",
				},
				isLoading: false,
				showSaveBtn: true,
				isSave: false,
				rules: {
					'content.somatization': [{
						required: false,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.forced': [{
						required: false,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.relationship': [{
						required: false,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.depression': [{
						required: false,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.anxiety': [{
						required: false,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.hostile': [{
						required: false,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.terrorist': [{
						required: false,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.paranoid': [{
						required: false,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.illness': [{
						required: false,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
				},
				dialogVisible:false,
				showAll:false,

			}
		},
		async created(){
			let query=this.$route.query;
			if(Number(query.datasources)!=1&&Number(query.datasources)!=2){
				let res=await api.checkPreVisibleTypes({
					recordId:this.recordId,
					type:4
				})
				this.showAll=res.data;
			}else{
				this.showAll=true
			}
		},
		methods: {
			async init(prescriptionItem) {
				this.prescriptionItem = prescriptionItem;
				if (this.prescriptionItem.hospitalPsychologicalVO.evalResult != null) {
					let evalResult = JSON.parse(this.prescriptionItem.hospitalPsychologicalVO.evalResult);
					if (evalResult.evalError == "") {
						this.tag = true;
						if (this.prescriptionItem.hospitalPsychologicalVO.content != null) {
							this.hidden = true;
							let content = JSON.parse(this.prescriptionItem.hospitalPsychologicalVO.content);
							if (content.result != '' && content.result != null) {
								this.tag = true;
							}
							// this.form = content;
							this.showSaveBtn = false;
							this.isSave = true;
						}
						this.form.result = evalResult.evalContent;
						this.dataHandle(evalResult.prescription);
					} else {
						this.tag = false;
					}
				} else {
					this.tag = false;
				}
				if (this.prescriptionItem.hospitalPsychologicalVO.content != null) {
					this.hidden = true;
					let content = JSON.parse(this.prescriptionItem.hospitalPsychologicalVO.content);
					if(content && content.result[0] != '' && content.result != null){
						this.tag = true;
					}
					this.form = content;
					this.showSaveBtn = false;
					this.isSave = true;
				} 
			},
			dataHandle(data){
				let list = data;
							for (let i = 0; i < list.length; i++) {
								if (list[i].factor == "敌对") {
									this.form.content.hostile = this.suggestFormat(list[i].suggest);
									this.form.content.hostileCheck = list[i].suggest != "" ? true :false;
								} else if (list[i].factor == "偏执") {
									this.form.content.paranoid = this.suggestFormat(list[i].suggest);
									this.form.content.paranoidCheck = list[i].suggest != "" ? true :false;
								} else if (list[i].factor == "强迫症状") {
									this.form.content.forced = this.suggestFormat(list[i].suggest);
									this.form.content.forcedCheck = list[i].suggest != "" ? true :false;
								} else if (list[i].factor == "焦虑") {
									this.form.content.anxiety = this.suggestFormat(list[i].suggest);
									this.form.content.anxietyCheck = list[i].suggest != "" ? true :false;
								} else if (list[i].factor == "精神病性") {
									this.form.content.illness = this.suggestFormat(list[i].suggest);
									this.form.content.illnessCheck = list[i].suggest != "" ? true :false;
								} else if (list[i].factor == "恐怖") {
									this.form.content.terrorist = this.suggestFormat(list[i].suggest);
									this.form.content.terroristCheck = list[i].suggest != "" ? true :false;
								} else if (list[i].factor == "抑郁") {
									this.form.content.depression = this.suggestFormat(list[i].suggest);
									this.form.content.depressionCheck = list[i].suggest != "" ? true :false;
								} else if (list[i].factor == "躯体化") {
									this.form.content.somatization= this.suggestFormat(list[i].suggest);
									this.form.content.somatizationCheck = list[i].suggest != "" ? true :false;
								} else if (list[i].factor == "人际关系敏感") {
									this.form.content.relationship = this.suggestFormat(list[i].suggest);
									this.form.content.relationshipCheck = list[i].suggest != "" ? true :false;
								}
							}
			},
			save(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						this.isLoading = true;
						let user = JSON.parse(localStorage.getItem("user"));
						let myDate = new Date();
						let time = myDate.getFullYear() + "/" + (myDate.getMonth() + 1) + "/" + myDate
							.getDate() + " " +
							myDate.toLocaleTimeString();
						let data = [];
						data.push({
							"content": JSON.stringify({
								result: this.form.result,
								content: this.form.content,
								name: user.data.name,
								time: time
							}),
							"datasources": this.datasources,
							"patientId": this.patientId,
							"prescriptionType": 4,
							"recordId": this.recordId,
							"state": 1
						});
						let res = await api.addPrescription(data);
						this.isLoading = false;
						if (res.code != 1000) {
							return this.$message.error(res.message);
						}
						this.showSaveBtn = false;
						this.isSave = true;

						this.form = {
							result: this.form.result,
							content: this.form.content,
							name: user.data.name,
							time: time
						}
						this.$emit('trigger-event',4);
					}
				});
			},
			update() {
				this.showSaveBtn = true;
				this.isSave = false;
				this.prescriptionItem.hospitalPsychologicalVO.pushTime=null

			},
			exportPdf() {
				htmlToPdf.outPutPdfFn(document.querySelector("#psychology_print"), "心理处方");
			},
			isHidden() {
				this.hidden = true;
			},
			removeDomain(item) {
				this.rules[item] = null;
			},
			addDomain(item) {
				this.rules[item] = [{
						required: true,
						message: '请输入处方内容',
						trigger: 'blur'
				}];
			},
			changeVal(val){
				this.rules = {
					'content.somatization': [{
						required: this.form.content.somatizationCheck,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.forced': [{
						required: this.form.content.forcedCheck,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.relationship': [{
						required: this.form.content.relationshipCheck,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.depression': [{
						required: this.form.content.depressionCheck,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.anxiety': [{
						required: this.form.content.anxietyCheck,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.hostile': [{
						required: this.form.content.hostileCheck,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.terrorist': [{
						required: this.form.content.terroristCheck,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.paranoid': [{
						required: this.form.content.paranoidCheck,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
					'content.illness': [{
						required: this.form.content.illnessCheck,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
				}
				
			},
			suggestFormat(v){
				if(Array.isArray(v)){
					if(v.length>0){
						let suggest = "";
						for(let i=0;i<v.length;i++){
							suggest += v[i]+"\n";
						}
						return suggest;
					} else {
						return '';
					}
				}else if(typeof(v)=='string'){
					return v;
				} else {
					return '';
				}
				
			},
			async delPrescription(){
				let res=await api.delPrescription({
					id:this.prescriptionItem.hospitalPsychologicalVO.id,
					prescriptionType:4
				})
				if (res.code != 1000) {
					return this.$message.error(res.message);
				}
				this.showSaveBtn = true;
				this.isSave = false;
				this.form={
					result: "",
					content: {
						somatization: "",
						forced: "",
						relationship: "",
						depression: "",
						anxiety: "",
						hostile: "",
						terrorist: "",
						paranoid: "",
						illness: "",
						somatizationCheck: true,
						forcedCheck: true,
						relationshipCheck: true,
						depressionCheck: true,
						anxietyCheck: true,
						hostileCheck: true,
						terroristCheck: true,
						paranoidCheck: true,
						illnessCheck: true
					},
					name: "",
					time: "",
				}
				this.$emit('trigger-event',4);
			}
		}
	}
</script>

<style lang="less" scoped>
.wrap{
	min-height: 300px;
}
::v-deep .alert{
		margin: 0 auto;
		width: 80%;
	}
	.body {
		font-size: 20px;
		padding: 20px 120px;
		color: #409EFF;
	}
	.exportPdf{
		float: right;
		margin-top: -18px;
		background: #fff;
		color: #699ce4;
		border-radius: 20px;
		padding: 6px 12px;
	}
	.know{
		color: #4D4D4D;
		cursor: pointer;
	}

	.goto{
		color: #FF5D5D;
		cursor: pointer;
	}

	.tag_text {
		line-height: 35px;
		font-size: 14px;
	}

	.tag_text_right {
		text-align: right;
	}

	.title {
		border-bottom: 3px solid #409EFF;
		margin-bottom: 20px;
		font-size: 20px;
	}

	.cf {
		font-size: 24px;
		text-align: center;
		color: #333333
	}

	.mTop10 {
		margin-top: 10px;
	}

	.m20 {
		margin: 20px 0;
	}

	.el-form .el-textarea {
		width: 100%;
		font-size: 18px;
		border-radius: 5px;
		resize: none;
		outline: none;
		line-height: 30px;
	}

	.save {
		text-align: right;
		padding: 20px 120px;
		margin-bottom: 30px;
	}

	.dealwith {
		color: #333333;
		font-size: 14px;;
		padding-top: 20px;
	}

	.saveText {
		background-color: #EFF8FE;
		border-color: #409EFF;
	}

	.text {
		font-size: 20px;
		margin: 15px 0;
		color: #616161;
	}
	
	.el-form .el-textarea {
		width: 100%;
		font-size: 14px;
		border-radius: 5px;
		resize: none;
		outline: none;
		line-height: 30px;
	}
	
	textarea{
		min-height: 150px;
		font-size: 14px;
	}	
	.tag {
		border-radius: 5px;
		height: 35px;
		margin: 0 30px;
		padding: 0 15px;
		font-size: 13px;
	}

	.color-grey {
		background-color: #E6E6E6;
		color: #4D4D4D;
	}

	.color-orange {
		background-color: #FFECEC;
		color: #FF5D5D;
	}

	.topic {
		background-color: #CFEAFC;
	}

	.sx {
		width: 5px;
		background-color: #409EFF;
		height: 22px;
		border-radius: 5px;
		float: left;
		margin-right: 10px;
		margin-top: 3px;
	}

	.desc {
		border-radius: 5px;
		border: 1px solid #409EFF;
		background-color: #EFF8FE;
		margin: 10px 0;
		padding: 20px;
		font-size: 14px;
		color: #333333;
		line-height: 30px;
		white-space: pre-line;
	}


	.tips {
		color: #616161;
		font-size: 14px;
		margin: 10px 0;
		line-height: 30px;
		text-indent: 2em;
	}
	
	/deep/.el-checkbox__label{
		font-size: 16px;
	}
	
	#psychology_print{
		.body {
			padding: 20px 120px;
			font-size: 18px;
			color: #409EFF;
		}
		
		.title {
			border-bottom: 3px solid #409EFF;
			margin-bottom: 20px;
		}
		
		
		.save {
			text-align: right;
			padding: 20px 120px;
		}
		
		.dealwith {
			color: #000;
			font-size: 16px;
			padding-top: 20px;
		}
		
		.saveText {
			background-color: #EFF8FE;
			border-color: #409EFF;
		}
		
		.text {
			font-size: 24px;
			margin: 15px 0;
			color: #000;
		}
		
		.tag {
			border-radius: 5px;
			height: 35px;
			margin: 0 30px;
			padding: 0 15px;
			font-size: 16px;
		}
		
		.h20{
			height: 20px;
		}
		
		.color-grey {
			background-color: #E6E6E6;
			color: #4D4D4D;
		}
		
		.color-orange {
			background-color: #FFECEC;
			color: #FF5D5D;
		}

		table {
			border: 1px solid #4D4D4D;
			border-collapse: collapse;
			border-spacing: 0;
		}
		
		table th {
			height: 40px;
			border: 1px solid #4D4D4D;
		}
		
		table td {
			padding: 10px;
			height: 20px;
			border: 1px solid #4D4D4D;
			width: 25%;
		}
		
		.table{
			text-align: center;
			font-size: 17px;
			color: #333333;
			width: 100%;
		}
		
		.topic {
			background-color: #CFEAFC;
		}
		
		.sx {
			width: 5px;
			background-color: #409EFF;
			height: 24px;
			border-radius: 5px;
			float: left;
			margin-right: 10px;
			margin-top: 3px;
		}
		
		.tips {
			color: #616161;
			font-size: 18px;
			margin: 10px 0;
			line-height: 30px;
			text-indent: 2em;
		}
		
		.el-form .el-input:not(.el-transfer-panel__filter){
			width: 60%;height: 30px;
		}
		
		.desc {
			border-radius: 5px;
			border: 1px solid #409EFF;
			background-color: #EFF8FE;
			margin: 30px 0;
			padding: 20px 20px 20px 40px;
			font-size: 18px;
			color: #000;
			line-height: 40px;
		}
		
		/deep/.el-form-item__content{
			margin-top: 18px;
		}
		
		/deep/.el-form-item__error {
			margin-left: 40%;
		}
		
		.text_dec{
			text-align: left;
			padding-left: 5px;
			line-height: 40px;
			margin-top: 18px
		}
		
		.know{
			color: #4D4D4D;
			cursor: pointer;
		}
		
		.goto{
			color: #FF5D5D;
			cursor: pointer;
		}
		
		.tag_text {
			line-height: 35px;
			font-size: 18px;
		}
		
		.tag_text_right {
			text-align: right;
		}
		
		.title {
			border-bottom: 3px solid #409EFF;
			margin-bottom: 20px;
			font-size: 26px;
		}
		
		.cf {
			font-size: 30px;
			text-align: center;
			color: #000
		}
		
		.mTop10 {
			margin-top: 10px;
		}
		
		.m20 {
			margin: 40px 0;
			font-size: 22px;
		}
		
	}
	
	
	.hide{
		position: absolute;
		z-index: -999;
	}
</style>
